import { isEqual } from 'lodash';
import { DestinationPlusRetentionStepValue } from 'wizards/models/combined/destination-plus-retention-model';
import { IBBFormModel } from 'wizards/models/ibb/ibb-form-model';

export interface WizardCombinedDataManagerHook {
  FormModel: IBBFormModel;
}

export class WizardCombinedDataManagerClass {
  private whereBackupPlusRetentionInternal: DestinationPlusRetentionStepValue;

  set whereBackupPlusRetention(value: DestinationPlusRetentionStepValue) {
    if (!isEqual(this.hooks.FormModel.whereBackupStep, value.whereBackupStep)) {
      this.hooks.FormModel.whereBackupStep = value.whereBackupStep;
    }

    if (!isEqual(this.hooks.FormModel.retentionPolicyStep, value.retentionPolicyStep)) {
      this.hooks.FormModel.retentionPolicyStep = value.retentionPolicyStep;
    }

    this.whereBackupPlusRetentionInternal.valid = value.valid;
  }

  get whereBackupPlusRetention(): DestinationPlusRetentionStepValue {
    const hasData = !!this.whereBackupPlusRetentionInternal;
    const whereBackupStepTheSame =
      hasData &&
      WizardCombinedDataManagerClass.isWhereBackupTheSame(
        this.whereBackupPlusRetentionInternal.whereBackupStep,
        this.hooks.FormModel.whereBackupStep
      );
    const retentionPolicyStepTheSame =
      hasData &&
      WizardCombinedDataManagerClass.isRetentionTheSame(
        this.whereBackupPlusRetentionInternal.retentionPolicyStep,
        this.hooks.FormModel.retentionPolicyStep
      );

    const needsUpdate = !hasData || !whereBackupStepTheSame || !retentionPolicyStepTheSame;

    if (needsUpdate) {
      this.whereBackupPlusRetentionInternal = {
        whereBackupStep: this.hooks.FormModel.whereBackupStep,
        retentionPolicyStep: this.hooks.FormModel.retentionPolicyStep,
        valid: this.whereBackupPlusRetentionInternal?.valid
      };
    }

    return this.whereBackupPlusRetentionInternal;
  }

  constructor(private hooks: WizardCombinedDataManagerHook) {}

  static isRetentionTheSame(
    currentValue: DestinationPlusRetentionStepValue['retentionPolicyStep'],
    newValue: DestinationPlusRetentionStepValue['retentionPolicyStep']
  ): boolean {
    return isEqual({ ...currentValue, valid: true }, { ...newValue, valid: true });
  }

  static isWhereBackupTheSame(
    currentValue: DestinationPlusRetentionStepValue['whereBackupStep'],
    newValue: DestinationPlusRetentionStepValue['whereBackupStep']
  ): boolean {
    return (
      !!currentValue.IsHybridBackup === !!newValue.IsHybridBackup &&
      currentValue.ConnectionID === newValue.ConnectionID &&
      currentValue.HybridID === newValue.HybridID
    );
  }
}
